<template>
  <div class="product-tip-pane">
    <div class="product-detail-ul">
      <div class="product-detail-li" v-for="(item, index) in tipList" :key="index">
        <i class="el-icon-close icon red" v-if="item.isErr"></i>
        <i class="el-icon-check icon" v-else></i>
        <span>{{ item.text }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    product: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    tipList() {
      if (!this.product) {
        return [];
      }
      const { isSuperModel, versionLevel } = this.product;
      let arr = [];
      if (versionLevel === 0) {
        arr = [
          { text: '课题有效期：3个月' },
          { text: '课题数据集500条' },
          { text: '支持使用平台预设数据维度' },
          { text: '支持自定义数据维度' },
          { text: '支持数据清洗' },
          { text: '支持数据验证' },
          { text: '支持数据统计分析的基础模型' },
          { text: '支持全套的可视化图表' },
          { text: '支持下载实证分析报告' }
        ];
      }
      if (versionLevel === 1) {
        arr = [
          { text: '亿级全量库最新数据，实时更新' },
          { text: '支持使用平台预设数据维度' },
          { text: '支持自定义数据维度' },
          { text: '支持数据清洗' },
          { text: '支持数据验证' },
          { text: '支持数据统计分析的基础模型' },
          { isErr: !isSuperModel, text: '支持数据高级模型（多元线性回归）' },
          { text: '支持全套的可视化图表' },
          { text: '支持下载实证分析报告' },
          { text: '支持多人协作（即将推出）' },
          { text: '提供专属客服服务' },
          { text: '课题有效期一年' }
        ];
      }
      if (versionLevel === 2) {
        arr = [
          { text: '亿级全量库最新数据，实时更新' },
          { isErr: !isSuperModel, text: '数据高级模型（多元线性回归）' },
          { text: '支持使用平台预设数据维度' },
          { text: '支持自定义数据维度' },
          { text: '支持数据清洗' },
          { text: '支持数据验证' },
          { text: '支持数据统计分析的基础模型' },
          { text: '支持全套的可视化图表' },
          { text: '支持下载实证分析报告' },
          { text: '支持一键导出校验后数据' },
          { text: '支持接入用户自有数据（即将推出）' },
          { text: '支持多人协作（即将推出）' },
          { text: '提供专属客服服务' },
          { text: '提供在线使用指导课程' },
          { text: '赠送实证分析的名家讲坛在线课程' },
          { text: '课题有效期一年' }
        ];
      }
      return arr;
    }
  }
};
</script>

<style lang="scss" scoped>
.product-tip-pane {
  .product-detail-ul {
    height: calc(100% - 20px);
    overflow-y: auto;

    .product-detail-li {
      box-sizing: border-box;
      position: relative;
      color: #3d465a;
      font-size: 12px;
      line-height: 17px;
      margin-top: 15px;
      padding-left: 22px;

      .icon {
        position: absolute;
        left: 0;
        top: 2px;
        color: #1991fb;
        font-size: 14px;
        margin-right: 10px;

        &.red {
          color: #f62733;
        }
      }
    }
  }
}
</style>
